import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {
  "Title": "Frame Helpers"
};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Frame helpers are building blocks to help you create frames quicker.
You 100% can build Frames without them but they make certain patterns in Frames easier.`}</p>
    <p>{`They are similar to the `}<a parentName="p" {...{
        "href": "/react-sim/controls/pre-defined-types"
      }}>{`pre-defined types`}</a>{` for `}<a parentName="p" {...{
        "href": "/react-sim/controls"
      }}>{`controls`}</a>{`.`}</p>
    <p>{`The Frame Helpers are:`}</p>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-sim/frame-helpers/grid"
        }}>{`Grid`}</a>{`,`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-sim/frame-helpers/canvas-frame"
        }}>{`CanvasFrame`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-sim/frame-helpers/time-series"
        }}>{`TimeSeries`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-sim/frame-helpers/time-series"
        }}>{`Counter`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/react-sim/frame-helpers/time-series"
        }}>{`Indicator`}</a></li>
    </ul>
    <p>{`To use a Frame Helper in your project, import it from `}<inlineCode parentName="p">{`react-sim`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import { Grid, CanvasFrame, TimeSeries, Counter, Indicator } from 'react-sim';
`}</code></pre>
    <p>{`Frame helpers are already connected with the Model, so if you use a Frame helper anywhere within a Model, it will receive the following props from that Model:`}</p>
    <ul>
      <li parentName="ul">{`cachedData,`}</li>
      <li parentName="ul">{`data,`}</li>
      <li parentName="ul">{`initData,`}</li>
      <li parentName="ul">{`params,`}</li>
      <li parentName="ul">{`results,`}</li>
      <li parentName="ul">{`tick,`}</li>
      <li parentName="ul">{`setData`}</li>
    </ul>
    <p>{`It's also possible to get the corresponding component, i.e. without these props automatically provided by the Model.
Just add Component to your `}<inlineCode parentName="p">{`import`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import {
  GridComponent,
  CanvasFrameComponent,
  TimeSeriesComponent,
  CounterComponent,
  IndicatorComponent,
} from 'react-sim';
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      